<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { addDnsPrefetch } from "@/helpers/prefetchHelper";
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  setup() {
    addDnsPrefetch();

    return {};
  },
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");
@import "@/assets/scss/global.scss";

#app {
  background-color: var(--background-color);
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>
